export const BACKEND_URL = `${
  process.env.REACT_APP_ENDPOINT_ENV === 'localhost'
    ? process.env.REACT_APP_BACKEND_URL_DEV
    : process.env.REACT_APP_BACKEND_URL
}/graphql`
